import { Box } from '@mui/material'
import {
  Apps20Regular,
  ChartMultiple24Regular,
  Globe24Regular,
  PlugConnected24Regular,
} from '@/components/Icon'
import styles from './AppListRow.module.scss'

const ICONS = {
  app: Apps20Regular,
  globe: Globe24Regular,
  plug: PlugConnected24Regular,
  chart: ChartMultiple24Regular,
}

const ACCENT_CLASS = {
  amber: styles.iconWrapAmber,
  terracotta: styles.iconWrapTerracotta,
  sage: styles.iconWrapSage,
  neutral: styles.iconWrapApp,
}

/**
 * @param {{
 *   app: import('@/data/mock/apps.js').NavApp,
 *   onClick?: () => void,
 * }} props
 */
export default function AppListRow({ app, onClick }) {
  const Icon = ICONS[app.icon] ?? Apps20Regular
  const accentClass = ACCENT_CLASS[app.accent] ?? styles.iconWrapApp
  const showFileName = Boolean(app.fileName)

  return (
    <button type="button" className={styles.row} onClick={onClick} aria-label={`Open ${app.name}`}>
      <Box
        className={`${styles.iconWrap} ${app.iconUrl ? styles.iconWrapLogo : accentClass}`}
        aria-hidden
      >
        {app.iconUrl ? (
          <img src={app.iconUrl} alt="" className={styles.logoImg} loading="lazy" decoding="async" />
        ) : (
          <Icon className={styles.icon} />
        )}
      </Box>
      <Box className={styles.textCol}>
        <span className={styles.name}>{app.name}</span>
        <span className={styles.description}>
          {app.description}
          {showFileName ? <span className={styles.fileName}> · {app.fileName}</span> : null}
        </span>
      </Box>
    </button>
  )
}
